import { Component, OnInit, Input } from '@angular/core';
import { CvdsField } from '../../model/interfaces';
//eslint-disable-next-line
import { SchemasService } from '@cv-invision/cv.invision-views.ux';

@Component({
	selector: 'cv-cvds-field',
	templateUrl: './cvds-field.component.html',
	styleUrls: ['./cvds-field.component.scss']
})
export class CvdsFieldComponent implements OnInit {
	@Input() field: CvdsField;
	@Input() showLabel = true;
	@Input() showValue = true;
	@Input() label: string;

	value: any;
	dataType: string;
	displayText: string;

	constructor(private schemaService: SchemasService) {}

	async ngOnInit(): Promise<void> {
		const value = this.field.Value;
		const { Path } = this.field;
		const Metadata = this.schemaService.getMetadataByPath(Path.replace(/[[[0-9+]']+/g, ''));

		if (Metadata) {
			const { DataType, DisplayText, Enumeration } = Metadata;
			this.dataType = DataType;
			this.displayText = DisplayText;
			switch (DataType) {
				case 'Boolean':
					this.value = value === 'True';
					break;
				case 'Enumerated':{
					const enumValue = Enumeration.find(elem => elem.Key === value);
					this.value = enumValue ? enumValue['Value'] : value;
					break;
				}
				default:
					this.value = value;
			}
		}
	}
}
